import {
  COVERAGE_CRITERIA_ALL,
  DEPENDENCY,
  DEMOGRAPHICS,
  HISTORY_TRANSLATION,
  INCOMPATIBILITY,
  INIT_POLICY_RULES,
  PLACE_OF_SERVICE,
  PXDX,
  tabOrder,
  UNLISTED_PA,
  MISSING_CC,
  PXDX_RFG_TAB,
  DEPENDENCY_RFG_TAB,
  DEMOGRAPHICS_RFG_TAB,
  HISTORY_TRANSLATION_RFG_TAB,
  INCOMPATIBILITY_RFG_TAB,
  PLACE_OF_SERVICE_RFG_TAB,
  UNLISTED_PA_RFG_TAB,
} from "../Constants/PolicyTranslationConstants";

import sortCCValues from "components/common/SharedHelperFunctions";
import dayjs from "dayjs";

export function getTabLabels() {
  const tempDynamicTabs = [];
  for (let table of tabOrder.keys()) {
    tempDynamicTabs.push({
      key: table,
      length: 0,
      display: table === PXDX ? true : false,
    });
  }
  return tempDynamicTabs;
}

export function filterRules(
  policyRulesList,
  // selectedCC,
  // selectedVariance,
  // selectedUseCase,
  // selectedLob,
  // selectedHealthPlan,
  setDynamicTabs,
  setTabValue,
  tabValue
) {
  const policyRules = structuredClone(INIT_POLICY_RULES);

  setDynamicTabs((prev) =>
    prev.map((tab) => {
      return {
        ...tab,
        length: 0,
        display: 0,
      };
    })
  );

  return policyRules;
}

export function getLobName(LobConfigKey, policyData) {
  const adoptionDecisions = policyData?.lobAdoptionDecisionList;
  const lobsSelected = Array.isArray(LobConfigKey)
    ? LobConfigKey.map((key) => {
        if (key.LobConfigKey) {
          return key.LobConfigKey;
        }
      })
    : [];

  if (lobsSelected.length !== 1) {
    return ""; //If multiple or no LOBs are selected, return empty string
  }
  const lobConfig = adoptionDecisions?.find(
    (decision) => parseInt(decision.id) === parseInt(lobsSelected[0])
  );

  return lobConfig ? lobConfig.lobDesc : "";
}

export function getLobNamesForFilter(LobConfigKey, policyData) {
  const adoptionDecisions = policyData?.lobAdoptionDecisionList;
  const lobConfig = adoptionDecisions?.find(
    (decision) => parseInt(decision.id) === parseInt(LobConfigKey)
  );
  return lobConfig ? lobConfig.lobDesc : "";
}
